module.exports = __webpack_public_path__ + "images/afe073f69876cc13853e04a08939b4fe-peru.png";